module.exports = __webpack_public_path__ + "img/icon_sun.df08ed0c.png";